import { Injectable } from '@angular/core';
import { IConfig } from '@app/shared/models/config.model';

const configServiceFactory = () => {
  const browserWindow = window || {};
  const browserWindowEnvName = '__env';
  const browserWindowEnv: IConfig = browserWindow[browserWindowEnvName] || {};

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return new ConfigService(browserWindowEnv);
};

@Injectable({
  providedIn: 'root',
  useFactory: configServiceFactory
})
export class ConfigService {

  get config(): IConfig {
    return this.appConfig;
  }

  constructor(private appConfig: IConfig) { }
}
